import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";

export const WildfireVHPIndexUsLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>Wildfire VHP Index (US)</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>
        {t("levels.noHazard")}
      </div>

      <div>
        <span style={legendItemStyle("#2ABB8C")}></span>
        {t("levels.low")}: 0 &lt; pw &lt; 178
      </div>
      <div>
        <span style={legendItemStyle("#F9E03F")}></span>
        {t("levels.moderate")}: 178 &le; pw &lt; 1000
      </div>
      <div>
        <span style={legendItemStyle("#FAA945")}></span>
        {t("levels.significant")}: 1000 &le; pw &lt; 10985
      </div>
      <div>
        <span style={legendItemStyle("#CF000F")}></span>
        {t("levels.high")}: pw &ge; 10985
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          processed by CyStellar
        </span>
      </div>
    </div>
  );
};
